import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnInit, Optional, Renderer2 } from '@angular/core';
import { AbstractControl, FormControl, FormControlName } from '@angular/forms';
import { QuillEditorComponent } from 'ngx-quill';
import { WithSubscription } from '@shared/base';

@Directive({
  selector: '[gccQuillEditor]'
})
export class QuillEditorDirective extends WithSubscription() implements OnInit, OnDestroy, AfterViewInit {
  @Input() public maxLength: number;

  get characters() {
    return this.charactersCount;
  }
  set characters(v: number) {
    this.charactersCount = v;
    this.updateCount();
  }

  get control() {
    return this.formControl || this.formControlName?.control;
  }

  private charactersCount = 0;
  private charactersContainer: HTMLDivElement;
  constructor(
    private editor: QuillEditorComponent,
    @Optional() private formControlName: FormControlName,
    @Optional() private formControl: FormControl,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    super();
  }

  public ngOnInit() {
    if (this.maxLength) {
      this.patchValidators();
      this.subs.add(
        this.editor.onEditorCreated.subscribe(quill => {
          this.characters = quill.getText().trim().length;
          quill.on('text-change', () => {
            this.characters = quill.getText().trim().length;
          });
        })
      );
    }
  }

  public ngAfterViewInit() {
    this.renderCount();
  }

  public ngOnDestroy() {
    this.renderer.removeChild(this.el.nativeElement.parentElement, this.charactersContainer);
  }

  private renderCount() {
    this.charactersContainer = this.renderer.createElement('div');
    this.renderer.setAttribute(this.charactersContainer, 'class', 'pt-1 mb-n5 caption text-gray text-right');
    this.renderer.insertBefore(
      this.el.nativeElement.parentElement,
      this.charactersContainer,
      this.el.nativeElement.nextSibling
    );
    this.updateCount();
  }

  private updateCount() {
    this.charactersContainer.innerText = `${this.characters} / ${this.maxLength} character limit`;
  }

  private patchValidators() {
    const newValidators = this.control?.validator
      ? [this.control.validator, maxLengthValidator(this.maxLength, () => this.characters)]
      : [maxLengthValidator(this.maxLength, () => this.characters)];
    this.control?.setValidators(newValidators);
  }
}

export function maxLengthValidator(maxLength: number, getLength: () => number) {
  return (control: AbstractControl) => {
    if (maxLength < getLength()) {
      return {
        maxLength: getLength()
      };
    }
  };
}
